import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/browser';
import { environment } from '@env/environment';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

if (environment.production && environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.production ? 'production' : 'development',
    release: environment.appVersion ? `obrasync-web@${environment.appVersion}` : undefined,
    initialScope: {
      tags: {
        project: 'obrasync-web',
        platform: 'frontend',
      },
    },
    tracesSampleRate: 0,
    profilesSampleRate: 0,
  });
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
